export * from '@giphy/js-util';

export function noUUIDRandom() {
    return Math.random().toString(36)
.slice(2, 10);
}
